'use strict';

import { appState } from './appState.js';
import { urlSafe } from './urlTools.js';
import { ajaxWrapNew, ResponseDispatcher } from './ajaxWrapNew.js';
import { connMTUpdater } from './connMTUpdater.js';
import { autoSyncer } from './autoSyncer.js';
import { setScroll } from './Scrolls.js';
import { searchHistoryWin } from './searchHistoryWin.js';
import { VarMgr } from './VarMgr.js';

import { initWMMAnimations } from './wmmAnimations.js';

function trySaveMapState() {
    if (typeof ConnectStatsMapState == 'undefined') return;
    if (typeof ConnectStatsMapState.instance != 'undefined' && ConnectStatsMapState.instance) {
        ConnectStatsMapState.instance.infoBox._saveMapState();
    }
}

function initConnectStatsPage(connectSid, moreUrl, statsUrl, loadscroll) {
    $('.cnsTb').on('click', '.country', function (event) {
        event.stopPropagation();

        trySaveMapState();
    });
    $('.cnsTb').on('click', '.jq-country', function (event) {
        $(this).find('.country').first().each(function () {
            event.preventDefault();
            event.stopPropagation();

            trySaveMapState();
            urlSafe.assign($(this).attr('href'));
        });
    });

    const $more = $('.more');
    let isChunkLoading = false;
    let observer = null;

    function loadNextChunk() {
        if (isChunkLoading) {
            return;
        }
        if ($more.hasClass('no-more')) {
            return;
        }
        isChunkLoading = true;

        ajaxWrapNew({
            url: moreUrl,
            method: 'GET',
            data: {
                ajax: 1,
                action: 'more',
                sid: $more.data('sid'),
                offset: $more.data('offset'),
                statsUrl: statsUrl
            },
            success: function (data) {
                ResponseDispatcher.handle(data, 'loadCityInfo more');

                try {
                    if (data.ok) {
                        $('.cnsTb').addClass('moreLoaded');
                        if (data.html) {
                            $('.cnsTb').append(data.html);
                        }
                        if (data.nextOffset && data.html) {
                            $more.data('offset', data.nextOffset);

                            $('.add-stats-back').data('offset', data.nextOffset);
                            appState.historyInstance.replaceState(history.state || {}, null, statsUrl + '&offset=' + data.nextOffset);

                        } else {
                            $more.hide().addClass('no-more');
                            if (observer) observer.disconnect();
                        }
                        /* if (data.setPage) {
                            $('.add-stats-back').data('page', data.setPage);
                            appState.historyInstance.replaceState(history.state || {}, null, statsUrl + '&page=' + data.setPage);
                        } */

                        if (isSentinelVisible()) {
                            loadNextChunk();
                        }
                    }
                } catch (e2) {
                    console.log(e2);
                }

                isChunkLoading = false;
            },
            dataType: 'json'
        }).always(() => {
            isChunkLoading = false;
        });
    };

    function isSentinelVisible() {
        let sentinel = document.getElementById('scroll-sentinel');
        if (!sentinel) return false;

        let rect = sentinel.getBoundingClientRect();
        // Pārbaudām, vai indikatora augšpuse ir ekrāna redzamajā daļā (+ 200px rezerve, ko minējām rootMargin)
        return (rect.top <= (window.innerHeight || document.documentElement.clientHeight) + 200);
    }

    function setupInfiniteScroll() {
        // Parametri observerim
        let options = {
            root: null,
            // '200px' nozīmē, ka ielāde sāksies 200px PIRMS lietotājs sasniedz apakšu.
            // Tas rada ilūziju, ka dati vienmēr jau ir klāt bez aizķeršanās.
            rootMargin: '0px 0px 200px 0px',
            threshold: 0
        };

        observer = new IntersectionObserver(function(entries) {
            // Ja mūsu "sentinel" elements ienāk ekrānā un mēs jau nelādējam datus
            if (entries[0].isIntersecting && !isChunkLoading) {
                loadNextChunk();
            }
        }, options);

        // Pasakām observerim vērot mūsu indikatoru
        let sentinel = document.getElementById('scroll-sentinel');
        if (sentinel) {
            observer.observe(sentinel);
        }
    }

    function stopInfiniteScroll() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }
    }

    $('.connectStats').on('click', 'a.more', function (event) {
        event.preventDefault();
        event.stopPropagation();

        loadNextChunk();
        setupInfiniteScroll();
    });
    $('.connectStats').on('click', 'a.less', function (event) {
        event.preventDefault();
        event.stopPropagation();

        stopInfiniteScroll();
        $('.no-more').show().removeClass('no-more');

        $(this).closest('.lessrow').nextAll().remove();
        $(this).closest('.moreLoaded').removeClass('moreLoaded');
        const prevOffset = $(this).closest('.lessrow').prevAll('.cnsRow').length;
        $('.more').attr('data-offset', prevOffset).data('offset', prevOffset);

        $('.add-stats-back').data('page', 1);
        appState.historyInstance.replaceState(history.state || {}, null, statsUrl + '&page=1');
    });

    $('.country-list-opener').on('click', function (event) {
        event.stopPropagation();

        new searchHistoryWin(1, this, 0, {});
    });

    /* $('.add-stats-back').on('click', 'a.country', function(event) {
        $(this).attr('href', $(this).attr('href') + $( '.add-stats-back' ).data('addback') + '&page=' + $( '.add-stats-back' ).data('page') + '&scroll=' + $( window ).scrollTop());
    }); */
    /* $('.add-stats-back').on('click', 'a.country', function(event) {

    }); */

    var $connMT = $('.connMTS');
    var connUpdater = new connMTUpdater({
        'selector': '.connMTS'
    });
    //window['connUpdater'] = connUpdater;

    autoSyncer.setGlobal('connectSID', connectSid);
    autoSyncer.add('stat-counter-countries', 'countries', {
        counter: $connMT.data('cnt')
    }, function (itemData) {
        if (itemData.counterTT) {
            connUpdater.updateTitle(itemData.counterTT);
        }
        if (itemData.counter !== undefined) {
            $('.connM0').text(itemData.counter);
            $('.connM1').text(itemData.counterM1);

            if ($connMT.data('cnt') != itemData.counter) {
                $connMT.data('cnt', itemData.counter);
                connUpdater.update(itemData.connMT, itemData.counter);
            }

            return {
                counter: itemData.counter
            };
        }
        return false;
    });

    if (loadscroll !== false) {
        setScroll(loadscroll);
    }
}


export function loadConnectStats() {
    const statsData = VarMgr.get('statsData');
    if (!statsData || statsData.isDetailed) {
        return;
    }

    initConnectStatsPage(statsData.connectSid, statsData.moreUrl, statsData.statsUrl, statsData.loadscroll);

    if ($('.mapAnimationNav').length) {
        initWMMAnimations();
    }

    $('.connectStats').on('click', '.addloadscroll', function(e) {
        e.preventDefault();
        let href = $(this).attr('href') + '&loadscroll=' + $( window ).scrollTop();
        urlSafe.assign(href);
    });
}